import { notEmpty } from '@festina-life/core'
import { TextInput } from '@festina-life/ui/forms'
import { useTranslate } from '@festina-life/ui/hooks'
import { type ChangeEvent, useState } from 'react'

import { MAX_TAB_LIMIT, MIN_TAB_LIMIT } from '../../context/defaultPreferences'
import { useLayoutContext } from '../../context/layoutContext'

export const TabLimitSettings = () => {
  const translate = useTranslate()
  const { preferences, onChangeView } = useLayoutContext()
  const { tabs } = preferences
  const [currentLimit, setCurrentLimit] = useState<string>(
    `${notEmpty(tabs.limit) ? tabs.limit : MAX_TAB_LIMIT}`,
  )
  const handleCurrentLimitChanged = (event: ChangeEvent<HTMLInputElement>) => {
    setCurrentLimit(event.target.value)
  }
  const handleCurrentLimitBlurred = () => {
    if (!Number.isNaN(currentLimit)) {
      const nextValue = Number(currentLimit)

      if (nextValue >= MIN_TAB_LIMIT && nextValue <= MAX_TAB_LIMIT) {
        onChangeView({
          ...preferences,
          tabs: { ...preferences.tabs, limit: Number(currentLimit) },
        })
      }
    }
  }

  return (
    <TextInput
      wrapperProps={{ label: translate('navigationTab.tabLimit') }}
      value={currentLimit}
      type="number"
      onChange={handleCurrentLimitChanged}
      onBlur={handleCurrentLimitBlurred}
      extraProps={{
        min: MIN_TAB_LIMIT,
        max: MAX_TAB_LIMIT,
      }}
      placeholder={`${MIN_TAB_LIMIT}-${MAX_TAB_LIMIT}`}
    />
  )
}
